import React from "react";
import { Link } from "react-router-dom";
import "./CommunityAvatar.css";

const getCommunityInitial = (name) =>
  (name || "C").trim().charAt(0).toUpperCase();

const CommunityAvatar = ({
  name,
  to = "",
  size = "medium",
  className = "",
  ariaLabel = "",
}) => {
  const classes = [
    "community-avatar",
    `community-avatar-${size}`,
    className,
  ]
    .filter(Boolean)
    .join(" ");
  const label = ariaLabel || `View ${name || "community"} profile`;

  if (to) {
    return (
      <Link className={classes} to={to} title={label} aria-label={label}>
        {getCommunityInitial(name)}
      </Link>
    );
  }

  return (
    <span className={classes} aria-label={name || "Community"}>
      {getCommunityInitial(name)}
    </span>
  );
};

export default CommunityAvatar;
